import { render, staticRenderFns } from "./mainUnits.vue?vue&type=template&id=e994d150&scoped=true"
import script from "./mainUnits.vue?vue&type=script&lang=js"
export * from "./mainUnits.vue?vue&type=script&lang=js"
import style0 from "./mainUnits.vue?vue&type=style&index=0&id=e994d150&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e994d150",
  null
  
)

export default component.exports